import _sfc_main from "./BuyBoxQuantity2.mjs";
/* empty css                 */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxQuantity = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-2c355759"]]);
export {
  BuyBoxQuantity as default
};
//# sourceMappingURL=BuyBoxQuantity.mjs.map
